import { Input } from '@avanta/shared/components/ui/Input';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDebounce } from '@avanta/shared/hooks/useDebounce';
import { useFetchSearchPsychologist } from '@avanta/shared/hooks/useFetchSearchPsychologist';
import { type Psychologist } from '@avanta/shared/types/psychologists';
import { Search } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SEARCH_PSYCHOLOGISTS_KEY_PREFIX } from '..';
import { BackButton } from '../../../../ui/BackButton';
import { PsychoCard } from '../../../../ui/PsychoCard';
import { StepSection } from '../../../../ui/StepSection';
import { DesktopViewSkeleton } from './Skeleton';

export const DesktopView = ({
  handleOnClick,
  handleOnBack,
}: {
  handleOnClick: (psychologist: Psychologist) => void;
  handleOnBack: () => void;
}): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search);
  const { data: psychologists = [], isLoading } = useFetchSearchPsychologist({
    name: debouncedSearch,
  });

  return (
    <div className="hidden am-lg:flex flex-col h-full relative">
      <div className="flex gap-6 w-full flex-1 min-h-0">
        <StepSection
          title={t(`${SEARCH_PSYCHOLOGISTS_KEY_PREFIX}title`)}
          className="w-full flex flex-col min-h-0 gap-5"
          containerClassName="relative w-full am-lg:gap-2"
          fullWidth
        >
          <Input
            placeholder={t(`${SEARCH_PSYCHOLOGISTS_KEY_PREFIX}search.placeholder`)}
            leftIcon={Search}
            onChange={e => setSearch(e.target.value)}
            className="w-full max-w-133.5"
          />
          <div className="flex flex-col gap-4 overflow-y-auto pb-3 min-h-0 scrollbar-custom w-full max-w-138">
            {isLoading ? (
              <DesktopViewSkeleton />
            ) : (
              psychologists.map(psychologist => (
                <PsychoCard
                  key={psychologist.id}
                  psychologist={psychologist}
                  onClick={() => handleOnClick(psychologist)}
                />
              ))
            )}
          </div>
        </StepSection>
      </div>
      <BackButton handleBack={handleOnBack} className="absolute bottom-5 am-2xl:-left-48 left-4" />
    </div>
  );
};
